export enum AceOpportunityDeclineReasonEnum {
  CUSTOMER_PROBLEM_UNCLEAR = 'Customer problem unclear',
  NEXT_STEPS_UNCLEAR = 'Next steps unclear',
  UNABLE_TO_SUPPORT = 'Unable to support',
  DUPLICATE_OF_PARTNER_REFERRAL = 'Duplicate of Partner Referral',
  RENEWAL_OPPORTUNITY = 'Renewal opportunity',
  OTHER = 'Other',
}
